import { render } from "./RiepilogoOrdini.vue?vue&type=template&id=d6b8768c&scoped=true"
import script from "./RiepilogoOrdini.vue?vue&type=script&lang=js"
export * from "./RiepilogoOrdini.vue?vue&type=script&lang=js"

import "./RiepilogoOrdini.vue?vue&type=style&index=0&id=d6b8768c&scoped=true&lang=css"

import exportComponent from "/root/frontTioPizza/mymenucli/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d6b8768c"]])

export default __exports__